import {
  Button,
  Col,
  Flex,
  Form,
  Radio,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { colors } from "../../../../../../constants/colors";
import Spinner from "../../../../../common/spinner/Spinner";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import styles from "./AutoCredit.module.scss";

const AutoCreditList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { tickets } = useSelector((state) => state.tickets);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: tickets?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* filter dependencies */
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("offers");
  /* filter dependencies */

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);

  const handleGetTableData = useCallback(() => {
    dispatch(getSystemSettingsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterStatus]);

  /* initial dependencies rendering */
  useEffect(() => {
    const getSubscriptionPlanNames = {
      PREMIUM: "Premium Plan",
      "ELITE-PREMIUM": "Elite Premium Plan",
    };

    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.AutoCredit.subscriptionPlanCode"),
        dataIndex: "subscription_plan_code",
        key: "subscription_plan_code",
      },
      {
        title: t("Modules.AutoCredit.subscriptionPlanName"),
        dataIndex: "subscription_plan_code",
        key: "subscription_plan_code",
        render: (_, record) => (
          <p>
            {record?.subscription_plan_code
              ? getSubscriptionPlanNames[record?.subscription_plan_code]
              : ""}
          </p>
        ),
      },
      {
        title: t("Modules.AutoCredit.autoCreditThreshold"),
        dataIndex: "auto_credit_threshold_count",
        key: "auto_credit_threshold_count",
      },
      {
        title: t("Modules.AutoCredit.autoCreditPeriod"),
        dataIndex: "auto_credit_period",
        key: "auto_credit_period",
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  background: record?.is_active
                    ? colors.lightTeal
                    : colors.lightPinkishRed,
                  color: record?.is_active
                    ? colors.darkTeal
                    : colors.darkMaroon,
                }}
              >
                {record?.is_active ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className={styles.adsListContainer}>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(baseRouteMakerForSuperAdmin(routes.AUTO_CREDIT))
            }
          />
          <Typography.Title level={2}>
            {t("activeSubs.autoCredit")}
          </Typography.Title>
        </Flex>

        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={systemSettings?.subscription_settings}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default AutoCreditList;
